// extracted by mini-css-extract-plugin
export default {"switcherButton":"tsOQhw","active":"vr3xZS","tooltip":"RYoli5"};